<template>
  <div>
    <h2 class="mb-4">รายการหนังสือที่ร้องขอ</h2>
    <CRow>
      <CCol md="3">
        <CInput
          v-model="word"
          placeholder="ค้นหา"
          @keyup.enter="handleSearch"
        />
      </CCol>
      <CCol md="3">
        <CSelect :value.sync="filterSelected" :options="filter" />
      </CCol>
      <CCol md="6">
        <div class="flex space-between mb-3">
          <CButton color="primary" @click="handleSearch"
            ><i class="fas fa-search"></i> ค้นหา
          </CButton>
          <CButton color="info" @click="handleDownload" :disabled="downloading">
            <i
              :class="
                downloading ? 'fas fa-spinner fa-spin' : 'far fa-file-excel'
              "
            ></i>
            {{ downloading ? 'Downloading...' : 'Excel download' }}
          </CButton>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-good-table
          mode="remote"
          :isLoading.sync="loading"
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' }
          }"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'requestedAt'">
              {{ props.row.requestedAt | datetimeFormat }}
            </span>
            <span v-else class="h6">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-ads-pagination
          :total-items="total"
          :max-visible-pages="5"
          :items-per-page="10"
          :page="search.page"
          :loading="loading"
        >
          <template slot-scope="props">
            <div class="vue-ads-pr-2 vue-ads-leading-loose">
              รายการที่ {{ props.start | decimalFormat }} ถึง
              {{ props.end | decimalFormat }} จาก
              {{ props.total | decimalFormat }} รายการ
            </div>
          </template>
          <template slot="buttons" slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              @page-change="pageChange(button.page)"
            />
          </template>
        </vue-ads-pagination>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from 'moment'

import apiRequestBook from '@/apis/requestBook.js'

export default {
  name: 'RequestBookNew',
  data() {
    return {
      loading: false,
      downloading: false,
      word: '',
      search: {},
      defaultSearch: {
        page: 0,
        limit: 10,
        sort: {
          field: 'name',
          type: 'desc'
        }
      },
      total: 0,
      filterSelected: 'bookName',
      filter: [
        { value: 'bookName', label: 'ชื่อหนังสือ / บทความ' },
        { value: 'authorName', label: 'ชื่อ - นามสกุลผู้ร้องขอ' }
      ],
      columns: [
        {
          label: 'ลำดับ',
          field: 'no',
          width: '50px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'ชื่อหนังสือ / บทความ',
          field: 'bookName',
          thClass: 'min-width-250',
          tdClass: 'min-width-250'
        },
        {
          label: 'ชื่อ - นามสกุลผู้ร้องขอ',
          field: 'authorName',
          width: '200px'
        },
        {
          label: 'ประเภท',
          field: 'bookTypeName',
          width: '200px'
        },
        {
          label: 'เวลาที่ร้องขอ',
          field: 'requestedAt',
          width: '250px'
        }
      ],
      rows: []
    }
  },
  created() {
    this.search = Object.assign({}, this.defaultSearch)
  },
  methods: {
    handleSearch() {
      this.search = Object.assign({}, this.defaultSearch)
      if (this.word) this.search[this.filterSelected] = this.word

      this.getList()
    },
    handleDownload() {
      this.downloading = true
      apiRequestBook
        .download()
        .then((data) => {
          const blob = new Blob([data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)

          link.target = '_blank'
          link.download = `${moment().format('YYYYMMDDHHmm')}_request_books.csv`
          link.click()
          URL.revokeObjectURL(link.href)

          this.downloading = false
        })
        .catch(() => {
          this.downloading = false
        })
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    onSortChange(params) {
      this.search.sort = params[0]
      this.getList()
    },
    getList() {
      this.loading = true

      apiRequestBook
        .getList(this.search)
        .then((result) => {
          this.total = result.data.totalDocs
          this.rows = []
          for (let i = 0; i < result.data.docs.length; i++) {
            const item = result.data.docs[i]
            this.rows.push({
              no: this.search.page * this.search.limit + i + 1,
              bookName: item.bookName,
              authorName: item.authorName,
              bookTypeName: item.bookTypeName,
              requestedAt: item.requestedAt
            })
          }

          this.loading = false
        })
        .catch(() => {
          this.rows = []
          this.loading = false
        })
    }
  }
}
</script>
